<script setup lang="ts">
import { useStarRating } from '../../services/ldjson'

const props = defineProps<{
  items: {
    key: string
    value: string
  }[]
}>()

const starRating = useStarRating(props)
useHead({
  script: [{ children: starRating, type: 'application/ld+json' }],
})
</script>

<template>
  <div />
</template>
